import React from 'react'

import ResetPasswordForm from './ResetPasswordForm'
import ForgottenPasswordForm from './ForgottenPasswordForm'
import SignInForm from './SignInForm'
import SignUpFormEmailVerification from './SignUpFormEmailVerification'
import SignUpFormEmailInUse from './SignUpFormEmailInUse'
import SignUpForm from './SignUpForm'
import ErrorPage from './ErrorPage'
import SendUserIdToGoogleAnalytics from './SendUserIdToGoogleAnalytics'
import PasswordResetResult from './PasswordResetResult'

const debugFormPicker = false
const isDebug = process.env.REACT_APP_DEBUG === '1'
const interval = isDebug ? 1000 : undefined

const isPasswordResetResultElement = () => {
  const successElement = document.getElementById('password-reset-success')
  const errorElement = document.getElementById('password-reset-error')
  return successElement || errorElement
}

const isSignInFormElement = () => {
  const element = document.getElementById(isDebug ? 'debugged-app' : 'api')
  const isUnifiedForm = element?.getAttribute('data-name') === 'Unified'
  debugFormPicker && isUnifiedForm && console.log('Sign in form')
  return isUnifiedForm
}

const isSignUpFormEmailVerificationElement = () => {
  // email or readOnlyEmail
  const isSignInSignUp = !`${window.location.href}${window.location.search}`.toLowerCase().includes('password')
  const hasKeyElement1 = document.getElementById('email')
  debugFormPicker && isSignInSignUp && hasKeyElement1 && console.log('Sign up form email verification')
  return isSignInSignUp && hasKeyElement1
}

const isSignUpEmailInUseElement = () => {
  // email or readOnlyEmail
  const hasKeyElement1 = document.getElementById('emailAddressAlreadyInUseContinueWithPasswordReset_true')
  debugFormPicker && hasKeyElement1 && console.log('Sign up form email in use')
  return hasKeyElement1
}

const isSignUpFormElement = () => {
  // readOnlyEmail
  const hasKeyElement1 = document.getElementById('readOnlyEmail')
  debugFormPicker && hasKeyElement1 && console.log('Sign up form')
  return hasKeyElement1
}

const isForgottenPasswordFormElement = () => {
  // email verification code but no new password
  const isPasswordReset = `${window.location.href}${window.location.search}`.toLowerCase().includes('password')
  const hasKeyElement = document.getElementById('email')
  const noConflictingKeyElement = document.getElementById('newPassword') === null
  debugFormPicker &&
    isPasswordReset &&
    hasKeyElement &&
    noConflictingKeyElement &&
    console.log('Forgotten password form')
  return hasKeyElement && noConflictingKeyElement
}

const isResetPasswordFormElement = () => {
  const hasKeyElement = document.getElementById('resetPassword')
  debugFormPicker && hasKeyElement && console.log('Password reset form')
  return hasKeyElement
}

const isErrorPageFormElement = () => {
  const hasKeyElement = document.getElementsByClassName('error-page-help').length > 0
  debugFormPicker && hasKeyElement && console.log('Error page form')
  return hasKeyElement
}

const isSendUserIdToGoogleAnalyticsElement = () => {
  // email or readOnlyEmail
  const hasKeyElement1 = document.getElementById('extension_GlobalId')
  debugFormPicker && hasKeyElement1 && console.log('Send user id to Google Analytics')
  return hasKeyElement1
}

const getComponents = () => {
  if (isPasswordResetResultElement()) {
    return <PasswordResetResult />
  }

  if (isSignInFormElement()) {
    return <SignInForm />
  }

  if (isSignUpFormEmailVerificationElement()) {
    return <SignUpFormEmailVerification />
  }

  if (isSignUpEmailInUseElement()) {
    return <SignUpFormEmailInUse />
  }

  if (isSendUserIdToGoogleAnalyticsElement()) {
    return <SendUserIdToGoogleAnalytics />
  }

  if (isSignUpFormElement()) {
    return <SignUpForm />
  }

  if (isForgottenPasswordFormElement()) {
    return <ForgottenPasswordForm />
  }

  if (isResetPasswordFormElement()) {
    return <ResetPasswordForm />
  }

  if (isErrorPageFormElement()) {
    return <ErrorPage />
  }

  return <div />
}

const useFormComponents = () => {
  const [components, setComponents] = React.useState(getComponents)
  React.useEffect(() => {
    if (interval) {
      const _interval = setInterval(() => setComponents(getComponents), interval)
      return () => clearInterval(_interval)
    }
    return () => {}
  }, [])

  return components
}

export default useFormComponents
